import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-file-icon',
    templateUrl: './file-icon.component.html',
    styleUrls: ['./file-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileIconComponent implements OnInit {

  @Input()
  path: string;

  icon: string;

  private icons = {
    doc: 'doc,docx,odt,docm,dotm,dot',
    xls: 'xls,xlsx,csv,xlsm,xlsb,xltx,xltm,ods',
    pdf: 'pdf',
    image: 'jpg,jpeg,png,bmp,gif,svg',
    video: 'avi,mpeg,mpg,mov,mp4,flv,mkv,wmv',
  };

  private readonly FALLBACK_ICON = 'fichier';

  constructor() {
  }

  ngOnInit() {
    if(this.path == 'folder'){
      this.icon = 'folder';
      return;
    }
    const extension = this.findExtension(this.path);
    this.icon = this.findIconByExtension(extension) || this.FALLBACK_ICON;
  }

  private findIconByExtension(extension: string) {
    const icon = Object.entries(this.icons).find(icon => icon[1].split(',').find(ext => ext == extension));
    return icon ? icon[0] : null;
  }

  private findExtension(filename: string) {
    if(!filename) {
      return null;
    }
    return filename.substr(filename.lastIndexOf('.') + 1);
  }

}
